import React from 'react';
import './MarqueeBanner.css';

const clubs = [
  { img: '/Team Logos/team1a.webp', name: 'Volf Soccer Academy' },
  { img: '/Team Logos/team2a.webp', name: 'ICSF Columbus FC' },
  { img: '/Team Logos/team3a.webp', name: 'Fraser Valley Soccer League' },
  { img: '/Team Logos/team4a.webp', name: 'Premier Soccer Academy' },
  { img: '/Team Logos/team5a.webp', name: 'TSS Rovers FC' },
  { img: '/Team Logos/team6a.webp', name: 'Total Soccer Academy' },
  { img: '/Team Logos/team7a.webp', name: 'WVFC' },
  { img: '/Team Logos/team8a.webp', name: 'Syracuse University Soccer' },
  { img: '/Team Logos/team9a.webp', name: 'SL Benfica' },
  { img: '/Team Logos/team10a.webp', name: 'Birmingham FC' },
  { img: '/Team Logos/team11a.webp', name: 'Blackburn Rovers FC' },
  { img: '/Team Logos/team12a.webp', name: 'Crystal Palace FC' },
  { img: '/Team Logos/team13a.webp', name: 'Borussia Dortmund' },
  { img: '/Team Logos/team14a.webp', name: 'Fluminense FC' },
  { img: '/Team Logos/team15a.webp', name: 'FK Bodo Glimt' },
  { img: '/Team Logos/team16a.webp', name: 'Real Sociedad' },
  { img: '/Team Logos/team17a.webp', name: 'Scottish Football Association' },
  { img: '/Team Logos/team18a.webp', name: 'Aston Villa FC' },
  { img: '/Team Logos/team19a.webp', name: 'Viking FK' },
  { img: '/Team Logos/team20a.webp', name: 'Maccabi Haifa FC' },
  { img: '/Team Logos/team21a.webp', name: 'Lillestrom SK' },
  { img: '/Team Logos/team22a.webp', name: 'Fulham FC' },
  { img: '/Team Logos/team23a.webp', name: 'Club Brugge KV' },
  { img: '/Team Logos/team24a.webp', name: 'FC Copenhagen' },
  { img: '/Team Logos/team25a.webp', name: 'Norwich City' },
  { img: '/Team Logos/team26a.webp', name: 'Randers FC' },
  { img: '/Team Logos/team27a.webp', name: 'Wellington Phoenix FC' },
  { img: '/Team Logos/team28a.webp', name: 'Whitecaps FC' },
  { img: '/Team Logos/team29a.webp', name: 'Manchester City' },
  { img: '/Team Logos/team30a.webp', name: 'English Football Association' },
  { img: '/Team Logos/team31a.webp', name: 'LA Galaxy' },
  { img: '/Team Logos/team32a.webp', name: 'Royal Antwerp FC' },
  { img: '/Team Logos/team33a.webp', name: 'Wolverhampton Wanderers FC' },
  { img: '/Team Logos/team34a.webp', name: 'FC Twente' },
  { img: '/Team Logos/team35a.webp', name: 'US Mens Soccer Team' },
  { img: '/Team Logos/team36a.webp', name: 'FC Utrecht' },
  { img: '/Team Logos/team37a.webp', name: 'Atlanta United FC' },
  { img: '/Team Logos/team38a.webp', name: 'Washington Spirit' },
  { img: '/Team Logos/team39a.webp', name: 'Newcastle FC' },
  { img: '/Team Logos/team40a.webp', name: 'Liverpool FC' },
];

// Duplicate the array for seamless loop
const track = [...clubs, ...clubs];

const ClubBadge = ({ img, name }) => (
  <div className="marquee-badge" title={name}>
    <img src={img} alt={`${name} logo`} className="badge-img" width="120" height="40" loading="lazy" />
  </div>
);

export default function MarqueeBanner() {
  return (
    <div className="marquee-section" id="marquee-trust">
      <div className="marquee-heading">
        <p className="marquee-trust-text">
          TRUSTED BY 100&apos;S OF ELITE TEAMS, ACADEMIES AND FEDERATIONS WORLDWIDE.
        </p>
      </div>

      <div className="marquee-outer" aria-label="Trusted clubs and federations">
        <div className="marquee-track">
          {track.map((club, i) => (
            <ClubBadge key={i} {...club} />
          ))}
        </div>
      </div>
    </div>
  );
}
